export default __webpack_public_path__ + "static/media/login_bg.6ccd7df6.jpg";